// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1XK41","content":"styles_content__cXimB","checkbox":"styles_checkbox__3Fuw-","checkboxLabel":"styles_checkboxLabel__aH2eC"};